export default "__VITE_ASSET__I8giDYcy__"